import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDateObj } from "@/hooks/metrics/useFormattedDateObj";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function DateObjCell(props: GridRenderCellParams<LicenseCheckDisplayData, Date>) {
  const formatted = useFormattedDateObj(props.value);
  // no i18n because it crashes, when trying to edit the date
  return <>{formatted.toLocaleString()}</>;
}
